var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fl-visitor-check" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "fl-visitor-check__tabs" }, [
        _c(
          "div",
          {
            class: {
              "fl-visitor-check__tabs__tab": true,
              "fl-visitor-check__tabs__tab_active": _vm.switcher.flCheckExpress,
            },
            on: {
              click: function ($event) {
                return _vm.setFlCheckTab("flCheckExpress")
              },
            },
          },
          [_vm._v("Экспресс")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              margin: "0 5px 0 -5px",
              "font-size": "24px",
              "font-weight": "400",
            },
          },
          [_vm._v("|")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "fl-visitor-check__tabs__tab": true,
              "fl-visitor-check__tabs__tab_active":
                _vm.switcher.flCheckStandart,
            },
            on: {
              click: function ($event) {
                return _vm.setFlCheckTab("flCheckStandart")
              },
            },
          },
          [_vm._v("Стандарт")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              margin: "0 5px 0 -5px",
              "font-size": "24px",
              "font-weight": "400",
            },
          },
          [_vm._v("|")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "fl-visitor-check__tabs__tab": true,
              "fl-visitor-check__tabs__tab_active": _vm.switcher.flCheckOptimum,
            },
            on: {
              click: function ($event) {
                return _vm.setFlCheckTab("flCheckOptimum")
              },
            },
          },
          [_vm._v("Оптимум")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              margin: "0 5px 0 -5px",
              "font-size": "24px",
              "font-weight": "400",
            },
          },
          [_vm._v("|")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "fl-visitor-check__tabs__tab": true,
              "fl-visitor-check__tabs__tab_active": _vm.switcher.flCheckMaximum,
            },
            on: {
              click: function ($event) {
                return _vm.setFlCheckTab("flCheckMaximum")
              },
            },
          },
          [_vm._v("Максимум")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              margin: "0 5px 0 -5px",
              "font-size": "24px",
              "font-weight": "400",
            },
          },
          [_vm._v("|")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "fl-visitor-check__tabs__tab": true,
              "fl-visitor-check__tabs__tab_active": _vm.switcher.addressCheck,
            },
            on: {
              click: function ($event) {
                return _vm.setFlCheckTab("addressCheck")
              },
            },
          },
          [_vm._v("Адрес")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.switcher.flCheckExpress ? _c("flCheckExpress") : _vm._e(),
          _vm._v(" "),
          _vm.switcher.flCheckStandart ? _c("flCheckStandart") : _vm._e(),
          _vm._v(" "),
          _vm.switcher.flCheckOptimum ? _c("flCheckOptimum") : _vm._e(),
          _vm._v(" "),
          _vm.switcher.flCheckMaximum ? _c("flCheckMaximum") : _vm._e(),
          _vm._v(" "),
          _vm.switcher.addressCheck ? _c("addressCheck") : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("Онлайн-проверка ФЛ")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }